import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { AuthService } from 'src/app/auth/auth.service';
import { AppSelectors } from 'src/app/state/app';

@Injectable({
  providedIn: 'root'
})
export class LogoutGuard implements CanActivate {
  constructor(private authService: AuthService) { }

  async canActivate() {
    await this.authService.logout(true);
    return false;
  }
}
